// ==== Общие события для Активного Вебинара
import A from 'utils/metrics/analytic'

// Заход на страницу активого вебинара
enum originActiveWebinar {
  LIVESTREAM = 'livestream',
}
const A_wa_openActiveWebinar = () => {
  A.setEvent('webinar_live_open', { origin: originActiveWebinar.LIVESTREAM })
  console.log('webinar_live_open', originActiveWebinar.LIVESTREAM)
}

// Во время текущего вебинара нажал на кнопку "?"

const A_wa_openFAQ = () => {
  A.setEvent('webinar_FAQ_open')
  console.log('webinar_FAQ_open')
}

// Оценил вебинар
enum originRaiting {
  ACTIVE = 'active',
  ACTIVEEND = 'active_end',
}

const A_wa_raitingClick = (origin: originRaiting) => {
  A.setEvent('rating_click', { origin })
}

export { A_wa_openActiveWebinar, A_wa_openFAQ, A_wa_raitingClick, originRaiting }
